import React from "react";
import { useMediaQuery } from "react-responsive";
import { Favourite, NotFavourite } from "../icons";

export default function Navigation({
  buttons,
  onClickFav,
  isFavorite,
  breadcrumb,
  condition,
  vehicleNo,
  vehicleName,
}) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="navigation">
      {isMobile === false && (
        <div>
          <p className="card-heading">{breadcrumb}</p>
          <div className="navigation-button-style">
            {buttons && (
              <button className={`bookmark-${isFavorite}`} onClick={onClickFav}>
                <i className="fa fa-star" /> Bookmark
              </button>
            )}
            {buttons && condition && condition === "DAMAGE" && (
              <button className="damaged-card">Damaged</button>
            )}
            {buttons && condition && condition === "USED" && (
              <button className="used-card">Used</button>
            )}
          </div>
        </div>
      )}
      {isMobile && (
        <div>
          <div
           className="contentContainerHeading"
          >
            <div className="single-heading">
              {vehicleNo && <span>No.{vehicleNo}</span>}
            </div>
            <div>
              {buttons && (
                <div className="contanierFavUseDam">
                  <div onClick={onClickFav}>
                    {isFavorite ? (
                      <Favourite style={{ width: 32, height: 32 }} />
                    ) : (
                      <NotFavourite style={{ width: 32, height: 32 }} />
                    )}
                  </div>

                  {condition && condition === "DAMAGE" && (
                    <button className="damaged-card">Damaged</button>
                  )}
                  {condition && condition === "USED" && (
                    <button className="used-card">Used</button>
                  )}
                </div>
              )}
            </div>
          </div>
          <div>
            <span className="vehiclesNames">{vehicleName} </span>
          </div>
        </div>
      )}
    </div>
  );
}
